export default __webpack_public_path__ + "static/media/ico_zoo.0c29a097.svg";